import { BASE_URL } from '../constants'
import { apiSlice } from './apiSlice'

export const formApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getform: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
        yearlyleave: builder.mutation({
            query: (formData) => ({
                url: BASE_URL,
                method: 'POST',
                body: formData,
            }),
        }),
    }),
})

export const { useGetformMutation, useYearlyleaveMutation } = formApiSlice